import '../Main.scss';

import {
    Col,
    Row,
} from 'reactstrap';

import * as React from 'react';
import { connect } from 'react-redux';

import {
    GetTenantName,
} from '../../Store/Tenant';

import { BorrowerPortalChildProps } from './BorrowerPortalV2';

import { ApplicationState } from '../../Store';

import { PortalTextBorrowerSharedLinkDeleted } from '../../Models/Api/strongbox.financialportal';
import { GetPortalText } from '../../Store/PortalAssets';
import { StringFormat } from '../../Utils/StringUtils';

type InjectedReduxState = {
    linkDeletedText?: PortalTextBorrowerSharedLinkDeleted;
    tenantVisibleName: string;
};

type InjectedActionCreators = {};

type Props = InjectedReduxState & InjectedActionCreators & BorrowerPortalChildProps;

export const ShareableLinkDeletedComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        linkDeletedText,
        tenantVisibleName,
    } = props;

    return (
        <Row
            className={'shareable-link-error-msg-row'}
            style={{
                marginTop: '30px'
            }}
        >
            <Col>
                <p>{linkDeletedText?.explanation1 || ''}</p>
                <p>{StringFormat(linkDeletedText?.templateExplanationIfStillNeeded || '{0}', tenantVisibleName)}</p>
            </Col>
        </Row>
    )
}

export const ShareableLinkDeleted = connect<InjectedReduxState, InjectedActionCreators, BorrowerPortalChildProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result = {
            linkDeletedText: GetPortalText<PortalTextBorrowerSharedLinkDeleted>(appState, 'borrowerSharedLinkDeleted'),
            tenantVisibleName: GetTenantName(appState),
        };

        return result;
    }
)(ShareableLinkDeletedComponent);
